import styled from 'styled-components';
import { breakpoints, touchFeedback } from '../../../styles/brand';

export const PageWrapper = styled.div`
  ${touchFeedback}

  padding: 2rem;
  min-height: calc(100vh - var(--header-height));
  background: #fafafa;

  @media (max-width: ${breakpoints.md}) {
    padding: 1rem;
  }
`;

export const PageHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e8e8e8;

  > a:first-child {
    background: none;
    display: flex;
    align-items: center;
    color: #323232;
    text-align: center;
    margin-bottom: 1rem;
    font-family: 'RedhatDisplay-Bold';
    font-size: 1.1em;
    width: fit-content;
    transition: opacity 0.3s;
    opacity: 0.8;

    svg {
      margin-right: 0.4rem;
    }

    &:hover {
      opacity: 1;

      > svg {
        opacity: 1;
      }
    }
  }

  > div {
    display: flex;
    align-items: center;
    gap: 0.4rem;
  }
`;

export const PageTitle = styled.h1`
  font-family: 'RedHatDisplay-Bold';
  font-size: 1.5rem;
  color: #323232;
  margin: 0;
`;

export const ContentLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: start;

  @media (max-width: ${breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`;

export const FormColumn = styled.div``;

export const ListColumn = styled.div`
  background: #fff;
  border: 1px solid #e2e2e2;
  border-radius: 0.75rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  overflow: hidden;
`;

export const ListHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #ebebeb;
  background: #fafafa;

  h2 {
    font-family: 'RedHatDisplay-Bold';
    font-size: 1rem;
    color: #323232;
    margin: 0;
  }
`;

export const EmptyState = styled.div`
  padding: 2.5rem 1.25rem;
  text-align: center;
  color: #9ca3af;
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.9rem;
`;

export const TeamCard = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #f5f5f5;

  &:last-child {
    border-bottom: none;
  }
`;

export const TeamInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  flex: 1;
  min-width: 0;
`;

export const TeamName = styled.span`
  font-family: 'RedHatDisplay-Bold';
  font-size: 0.92rem;
  color: #323232;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TeamMeta = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.8rem;
  color: #6b7280;
`;

export const MembersList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  margin-top: 0.25rem;
`;

export const MemberChip = styled.span`
  background: #f0f4ff;
  color: #1e88e5;
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.75rem;
  padding: 0.15rem 0.5rem;
  border-radius: 0.35rem;
  border: 1px solid #c7d9f8;
`;

export const RemoveButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.7rem;
  border: 1px solid #fca5a5;
  border-radius: 0.45rem;
  background: #fff5f5;
  color: #dc2626;
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.8rem;
  cursor: pointer;
  flex-shrink: 0;
  transition:
    background 0.18s,
    border-color 0.18s;

  &:hover {
    background: #fee2e2;
    border-color: #dc2626;
  }
`;

/* ── Confirm modal ── */
export const ConfirmOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
`;

export const ConfirmDialog = styled.div`
  background: #fff;
  border-radius: 0.75rem;
  padding: 1.75rem;
  width: min(92vw, 400px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
`;

export const ConfirmTitle = styled.h3`
  font-family: 'RedHatDisplay-Bold';
  font-size: 1.1rem;
  color: #323232;
  margin: 0;
`;

export const ConfirmText = styled.p`
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.9rem;
  color: #4b5563;
  margin: 0;
  line-height: 1.5;

  strong {
    color: #323232;
    font-family: 'RedHatDisplay-Bold';
  }
`;

export const ConfirmActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.65rem;
  margin-top: 0.25rem;
`;

export const DangerButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  height: 2.6rem;
  padding: 0 1.2rem;
  border: none;
  border-radius: 0.5rem;
  background: #dc2626;
  color: #fff;
  font-family: 'RedHatDisplay-Bold';
  font-size: 0.9rem;
  cursor: pointer;
  transition: background 0.18s;

  &:hover:not(:disabled) {
    background: #b91c1c;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4rem;
`;

export const Spinner = styled.div`
  width: 2rem;
  height: 2rem;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #ff9800;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
